"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerTransactionAPI = void 0;
const shared_1 = require("@getgreenline/shared");
const WorldpayServerCommonAPI_1 = require("../WorldpayServerCommonAPI");
class WorldpayServerTransactionAPI extends WorldpayServerCommonAPI_1.WorldpayServerCommonAPI {
    constructor(params) {
        super(params.appSpecificHeaders);
        this.submitSaleAsync = (params) => __awaiter(this, void 0, void 0, function* () {
            const { requestId, tenantSpecificHeaders, callbackUrl, payload } = params;
            const headers = Object.assign(Object.assign({}, this.getHeaders(requestId, tenantSpecificHeaders)), { 'tp-isasync': true });
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = yield shared_1.axios.post(`${this.apiUrl}/sale`, payload, {
                    headers,
                });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.submitRefundAsync = (params) => __awaiter(this, void 0, void 0, function* () {
            const { requestId, tenantSpecificHeaders, callbackUrl, payload } = params;
            const headers = Object.assign(Object.assign({}, this.getHeaders(requestId, tenantSpecificHeaders)), { 'tp-isasync': true });
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = yield shared_1.axios.post(`${this.apiUrl}/refund`, payload, { headers });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getTransactionFromResourceLocation = ({ requestId, tenantSpecificHeaders, resourceLocation, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.getResourceFromLocation({
                    requestId,
                    tenantSpecificHeaders,
                    resourceLocation,
                });
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getHeaders = (requestId, tenantSpecificHeaders) => {
            return Object.assign(Object.assign({}, this.getCommonHeaders(requestId, tenantSpecificHeaders)), { 'tp-authorization': '2.0' });
        };
        this.apiUrl = `${params.baseUrl}/v1`;
    }
}
exports.WorldpayServerTransactionAPI = WorldpayServerTransactionAPI;
//# sourceMappingURL=WorldpayServerTransactionAPI.js.map